module.exports = signals;